import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {IncidentReportsComponent} from './incident-reports.component';
import {IncidentReportsService} from '../../services/incident-reports.service';
import {IncidentReportsModalComponent} from './incident-reports-modal/incident-reports-modal.component';
import {IncidentReportsListComponent} from './incident-reports-list/incident-reports-list.component';
import {IncidentReportsFilterComponent} from '../../components/incident-reports-filter/incident-reports-filter.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {SendIncidentReportModalComponent} from './send-incident-report-modal/send-incident-report-modal.component';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';
import {FilterByPropertyPipeModule} from '../../pipes/filter-by-property-pipe/filter-by-property-pipe.module';
import {IncidentReportHistoryModalComponent} from './incident-report-history-modal/incident-report-history-modal.component';
import {IncidentReportDetailedViewComponent} from './incident-report-detailed-view/incident-report-detailed-view.component';
import { IncidentReportsCommentsComponent } from './incident-report-detailed-view/incident-reports-comments/incident-reports-comments.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        ScrollDispatchModule,
        FilterByPropertyPipeModule,
        UtilsModule
    ],
    declarations: [
        IncidentReportsComponent,
        IncidentReportsModalComponent,
        IncidentReportsListComponent,
        IncidentReportsFilterComponent,
        SendIncidentReportModalComponent,
        IncidentReportHistoryModalComponent,
        IncidentReportDetailedViewComponent,
        IncidentReportsCommentsComponent
    ],
    exports: [
        IncidentReportsModalComponent
    ],
    providers: [
        IncidentReportsService
    ]
})
export class IncidentReportsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-reports.module.ts